import {useState, useEffect} from 'react'
import Navbar from './Navbar'
import axios from 'axios'
import "./Contact.css"

const Contact = () => {
    const [ emailForm, setEmailForm] = useState({
        name: "",
        email: "",
        to: process.env.REACT_APP_EMAIL,
        description: "",
    })
    const [message, setMessage] = useState(null)

    const inputChange = (e) => {
        const {name, value} = e.target

        setEmailForm((prev) => ({
            ...prev,
            [name]: value,
        }))
    }
      useEffect(() => {
        const scrollToTop = () => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        scrollToTop()
      }, [])

    const handleSubmit = async (e) => {
        e.preventDefault()

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/contact/send-email`, emailForm)
            setMessage(response.data.message)
        } catch (err) {
            setMessage(err.response?.data?.message)
        }
    }


  return (
    <div>
        <Navbar />
        <div className='business-container'>
            <h2 className='services-title'>Kontaktní formulář</h2>
            <form className="contact-form" onSubmit={handleSubmit}>
                <input 
                    type='text'
                    name="name"
                    value={emailForm.name}
                    onChange={inputChange}
                    placeholder='Jméno a přijmení'
                    className='login-input'
                    required
                />
                <input 
                    type='email'
                    name="email"
                    value={emailForm.email}
                    onChange={inputChange}
                    placeholder='Email'
                    className='login-input'
                    required
                />
                <textarea
                    type='text'
                    name="description"
                    value={emailForm.description}
                    onChange={inputChange}
                    placeholder='Poznámka...'
                    className='login-input'
                    required
                />
                <button className="profile-button" type="submit">Odeslat</button>

            </form>
            {message && <p className="message">{message}</p>}
            <h2 className='services-title'>Kontaktní údaje</h2>
            <div className='contact-container-new'>
                <div ><h5 className='check-title'>Provozovatel: </h5><p>{process.env.REACT_APP_NAME}</p></div>
                <div><h5 className='check-title'>Email: </h5><p>{process.env.REACT_APP_EMAIL}</p></div>
                <div><h5 className='check-title'>IČ: </h5><p>{process.env.REACT_APP_IC}</p></div>
                <div><h5 className='check-title'>Sídlo: </h5><p>{process.env.REACT_APP_HOME}</p></div>
            </div>
        </div>
    </div>
  )
}

export default Contact